import React from 'react';
import classNames from 'classnames';
import styles from './PaymentList.scss';

const CARD_PROPERTIES = {
  number: 'Card Number',
  type: 'Card Type',
  expiry: 'Expiry Date',
};

function PaymentList({ card }) {
  const paymentList = Object.entries(card).map(entry => (
    <li className={styles.item}>
      <span
        className={classNames(styles.cell, styles.label)}
      >
        {CARD_PROPERTIES[entry[0]]}
      </span>
      <span
        className={classNames(styles.cell, styles.value)}
      >
        {entry[1]}
      </span>
    </li>
  ));
  return (
    <ul className={styles.root}>{paymentList}</ul>
  );
}

export default PaymentList;
